import { render, staticRenderFns } from "./RelayStatus.vue?vue&type=template&id=3695c185&"
import script from "./RelayStatus.vue?vue&type=script&lang=ts&"
export * from "./RelayStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports